import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';
import PaperSection from '@rossum/components/paper-section/PaperSection';
import { IconInfoSquareRounded } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';
import ControlledToggle from '../../../../../components/ReactHookForm/Toggle';
import { CONFIRMED_STATE_LINK } from '../../../../../constants/values';
import { linebreak, link } from '../../../../../lib/formaterValues';
import { queueSettingsRowSx } from '../../../queueSettingsRowSx';
import { QueueSettingsData } from './formType';
import QueueSettingsLabel from './QueueSettingsLabel';

type ConfirmStateProps = {
  control: Control<QueueSettingsData>;
  useConfirmedState: boolean;
};

const ConfirmState = ({ control, useConfirmedState }: ConfirmStateProps) => {
  const intl = useIntl();

  return (
    <PaperSection
      title={intl.formatMessage({
        id: 'containers.settings.queues.titles.confirmedState',
      })}
      tooltip={
        <Tooltip
          placement="top"
          title={
            intl.formatMessage(
              {
                id: 'containers.settings.queues.confirmedState.headerTooltip',
              },
              {
                link: link(`${CONFIRMED_STATE_LINK}`),
                linebreak,
              }
            ) ?? ''
          }
        >
          <SvgIcon fontSize="medium">
            <IconInfoSquareRounded />
          </SvgIcon>
        </Tooltip>
      }
    >
      <Stack direction="row" sx={queueSettingsRowSx}>
        <div>
          <QueueSettingsLabel
            titleId="containers.settings.queues.confirmedState.label"
            tooltipId="containers.settings.queues.confirmedState.tooltip"
          />
        </div>
        <Stack direction="row">
          <ControlledToggle<QueueSettingsData>
            control={control}
            name="useConfirmedState"
          />
        </Stack>
      </Stack>
      <Stack direction="row" sx={queueSettingsRowSx}>
        <div>
          <QueueSettingsLabel
            titleId="containers.settings.queues.confirmedStateHideButton.label"
            tooltipId="containers.settings.queues.confirmedStateHideButton.tooltip"
          />
        </div>
        <Stack direction="row">
          <Tooltip
            title={
              useConfirmedState
                ? ''
                : intl.formatMessage({
                    id: 'containers.settings.queues.confirmedStateHideButton.disabled.tooltip',
                  })
            }
          >
            <div>
              <ControlledToggle<QueueSettingsData>
                control={control}
                disabled={!useConfirmedState}
                name="hideExportButton"
              />
            </div>
          </Tooltip>
        </Stack>
      </Stack>
    </PaperSection>
  );
};

export default ConfirmState;
